define("SDB.Modal.Button.View", [
  "SCView",
  "sdb_modal_button.tpl",
  "SDB.Modal.Content.View",
  "SDB.SelectYourVehicle.View",
], function (
  SCViewModule,
  sdb_modal_button_tpl,
  SDBModalContentView,
  SDBSelectYourVehicleView
) {
  "use strict";
  var SCView = SCViewModule.SCView;

  var SDBModalButtonView = function SDBModalButtonView(options) {
    SCView.call(this);

    this.options = options || {};
    this.template = sdb_modal_button_tpl;

    this.attributes = {
      id: "SDBModalButtonViewId",
      class: "sdb-modal-button-view",
    };

    this.toggleModalHandler = function toggleModalHandler(e) {
      var Layout = this.options.container.getComponent("Layout");

      this.modalView = new SDBModalContentView({
        parentView: this,
        contentView: SDBSelectYourVehicleView,
        container: this.options.container,
        pageHeader: "Select Your Vehicle",
        isMake: this.options.isMake,
        notRedirect: this.options.notRedirect,
      });

      Layout.showContent(this.modalView, { showInModal: true });
    };

    this.events = {
      'click [data-action="toggle-custom-modal"]': "toggleModalHandler",
    };

    this.getContext = function getContext() {
      return {
        buttonLabel: this.buttonLabel || "select your vehicle",
      };
    };
  };

  SDBModalButtonView.prototype = Object.create(SCView.prototype);
  SDBModalButtonView.prototype.cosntructor = SDBModalButtonView;

  return SDBModalButtonView;
});
